export default __webpack_public_path__ + "static/unico-digital-nacional-23d10b824c3ebb71fcd5b84f68575134.jpg";